<app-feature-hero
    variant="ims"
    title="ITIM SLA Management"
    description="Maximize application, network & server performance with SLA management features"
    image=""
    imageAlt=""
></app-feature-hero>


<section class="container section-spacing">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">Continuously Track SLA Process To Gain Full ITIM Visibility</h2>
                <p class="section-paragraph">Infraon ITIM elevates the SLA journeys of your applications, networks, and
                    servers by enhancing service speed and quality. Customize escalation protocols, set routing rules,
                    and more with an impactful and intuitive SLA dashboard.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-img-right justify-content-center">
                <img src="/assets/img/feature-pages/infraon-ims/sla-management/itim-sla-main-img.png" width="80%"
                    alt="SLA Management">
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Feature Highlights</h2>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/sla-management/config.svg"
                    alt="Config Icon">
            </div>
            <p class="section-title-s">Integrated SLA Management</p>
            <p class="section-paragraph-s">Manage end-to-end SLA lifecycles to keep track of multiple service
                commitments & increase the efficiency – based on ITIL best practices.</p>
        </div>

        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/sla-management/monitor.svg"
                    alt="Monitor screen">
            </div>
            <p class="section-title-s">SLA-Based Performance Monitoring</p>
            <p class="section-paragraph-s">Configure, edit, preview & share SLA data with a 360-degree view into
                real-time availability & performance insights.</p>
        </div>
    </div>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/sla-management/clock.svg"
                    alt="clock icon">
            </div>
            <p class="section-title-s">Real-Time Compliance Tracking</p>
            <p class="section-paragraph-s">Monitor at-risk SLA health & instantly check for violations to identify them
                in real-time before they lead to compliance issues</p>
        </div>

        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/sla-management/headphones.svg"
                    alt="Headphones icon">
            </div>
            <p class="section-title-s">Total Support - Business Hours & Holidays</p>
            <p class="section-paragraph-s">Easily configure & schedule IT support for networks, applications & servers
                for business hours & official holidays.</p>
        </div>
    </div>
</section>


<section class="bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 d-flex align-items-center position-relative bg-black-dots">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                <h2 class="section-title">Other Features</h2>

                <div class="row mx-0 px-0">
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">IT Inventory Management</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Incident & Fault Management</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Event Management</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Alerts & Notifications</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box d-flex justify-content-center position-absolute"
                style="right: 0;bottom: 0;">
                <img src="/assets/img/feature-pages/infraon-ims/sla-management/woman-1.webp" class="w-80" alt="woman point at features">
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>